import { useParams } from "react-router-dom";
import { useState,useRef,useEffect } from "react";

import {  createCameraVideoTrack, createMicrophoneAudioTrack, useMediaDevice } from "@videosdk.live/react-sdk";


 


const JoinScreen = ({ meetingId,getMeetingAndToken }) => {
 

    // function onDeviceChanged(devices) {
    //     console.log("Device Changed", devices)
    // }

    // const { checkPermissions, requestPermission,getCameras,getMicrophones,getPlaybackDevices } = useMediaDevice({ onDeviceChanged });
    // const checkMediaPermission = async () => {
    //     //These methods return a Promise that resolve to a Map<string, boolean> object.
    //     const checkAudioPermission = await checkPermissions("audio"); //For getting audio permission
    //     const checkVideoPermission = await checkPermissions("video"); //For getting video permission
    //     const checkAudioVideoPermission = await checkPermissions("audio_video"); //For getting both audio and video permissions
    //     // Output: Map object for both audio and video permission:
    //     console.log(checkAudioPermission);
    //     /*
    //           Map(2)
    //           0 : {"audio" => true}
    //               key: "audio"
    //               value: true
    //           1 : {"video" => true}
    //               key: "video"
    //               value: true
    //       */
    //   };

    //   const requestAudioVideoPermission = async () => {
    //     try {
    //       //These methods return a Promise that resolve to a Map<string, boolean> object.
    //       const requestAudioPermission = await requestPermission("audio"); //For Requesting Audio Permission
    //       const requestVideoPermission = await requestPermission("video"); //For Requesting Video Permission
    //       const requestAudioVideoPermission = await requestPermission("audio_video"); //For Requesting Audio and Video Permissions
    //     } catch (ex) {
    //       console.log("Error in requestPermission ", ex);
    //     }
    //   };

    //   const getMediaDevices = async () => {
    //     try {
    //       //Method to get all available webcams.
    //       //It returns a Promise that is resolved with an array of CameraDeviceInfo objects describing the video input devices.
    //       let webcams = await getCameras();
    //       //Method to get all available Microphones.
    //       //It returns a Promise that is resolved with an array of MicrophoneDeviceInfo objects describing the audio input devices.
    //       let mics = await getMicrophones();
    //       //Method to get all available speakers.
    //       //It returns a Promise that is resolved with an array of PlaybackDeviceInfo objects describing the playback devices.
    //       let speakers = await getPlaybackDevices();
    //       console.log(webcams);
    //     } catch (err) {
    //       console.log("Error in getting audio or video devices", err);
    //     }
    //   };


 
      
      

    //   useEffect(()=>{

    //     requestAudioVideoPermission();
    //     checkMediaPermission();
    //     getMediaDevices();
    //     return () => { };
    //   },[])

 

    // const [meetingId, setMeetingId] = useState(null);
    const onClick = async () => {
      await getMeetingAndToken(meetingId);
    };


 

    return (
        <div className="col-12 mt-3 ">

            <button className="w-100 btn btn-label-primary d-flex align-items-center" type="button"
                onClick={onClick}>
                <span className="me-2">Generate Meeting1</span><i className="bx bx-chevron-right bx-sm lh-1 scaleX-n1-rtl" />
            </button>


            <div className="card p-2 h-100 shadow-none border d-none">
                <div className="card-body p-4 pt-2">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        {/* <span className="badge bg-label-primary">Meeting Area</span> */}
                   
                        <p className="d-flex align-items-center justify-content-center fw-medium gap-1 mb-0">
                            {/* Affiants : {transactionsForOath.length ?? 0} / 10 */}
                        </p>
                    </div>
                    {/* <span className="h5">Create or Join an existing meeting.</span>
                    <p className=" align-items-center mb-4 mt-2"><i className="bx bx-time-five me-1" />There are <span className="text-info fw-bold">{transactionsForOath.length ?? 0}</span> participants ready to take an oath. Just <span className="text-danger fw-bold">click</span> the "Generate Meeting" button and <span className="text-danger fw-bold">notify the affiants</span> to start video conference.</p>


                    <input type="search" placeholder="Enter Meeting ID" className="form-control me-4 mb-3" onChange={(e) => {
                        setMeetingId(e.target.value);
                    }} /> */}



                    <div className="d-flex flex-column flex-md-row gap-4 text-nowrap flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap">
                        {/* <button className="w-100 btn btn-label-secondary d-flex align-items-center" onClick={()=>{
                            onClick();
                        }}>
                            <i className="bx bx-rotate-right bx-sm align-middle scaleX-n1-rtl me-2" /><span>Join a meeting</span>
                        </button> */}
                        {/* <button className="w-100 btn btn-label-primary d-flex align-items-center" type="button"
                            onClick={onClick}>
                            <span className="me-2">Generate Meeting</span><i className="bx bx-chevron-right bx-sm lh-1 scaleX-n1-rtl" />
                        </button> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default JoinScreen;